import { Component, NgZone, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { DataService } from 'src/app/services/data.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { TranslateService } from '@ngx-translate/core';

import { MatDialog } from '@angular/material/dialog';
// Generic dialog used for action confirmations
import { ConfirmReservationDialogComponent } from '../dialogs/confirm-reservation-dialog/confirm-reservation-dialog.component';

import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';


@Component({
  selector: 'app-order-family',
  templateUrl: './order-family.component.html',
  styleUrls: ['./order-family.component.sass']
})
export class OrderFamilyComponent implements OnInit {

  ordersListSubs: Subscription;
  orders: any;
  productsOrder: any;
  // orderForm: FormGroup;

  showPrimarySpinner: boolean = false;
  isList: boolean = true;
  isNew: boolean = true;
  url_invoice: string = '';
  modification_date: string;
  creation_date: string;
  reference: string;
  value: string;
  value_shipping: string = '';
  total: any = 0;
  status: string;
  logo_url: string;
  product_photo: any;
  user_role: any;
  style: any;

  displayedColumns: string[] = ['reference', 'value', 'status', 'creation_date', 'actions'];
  displayedColumns2: string[] = ['product_name_es', 'product_name_en', 'product_name_cat', 'description', 'quantity', 'value', 'actions'];
  dataSource = new MatTableDataSource<any>();
  dataSource2 = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, {}) sort: MatSort;

  showOrderFamilyProgressBar: boolean = true;
  showOrderFamilyProgressBar2: boolean = true;

  constructor(
    public dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private dialog: MatDialog,
    private snackbar: MatSnackBar
  ) { }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.dataSource2.sort = this.sort;
    this.dataSource2.paginator = this.paginator;


  }


  ngOnInit() {
    this.dataService.getRole().subscribe(res => {
      this.user_role = res;
    });

    // this.orderForm = this.formBuilder.group({
    //   id: new FormControl(0, Validators.required),
    //   reference: new FormControl({value:'', disabled: true}, Validators.required),
    //   value: new FormControl('',Validators.required)
    // });


    // this.orders = this.getOrders();
    // this.routeSub = 
    this.showOrderFamilyProgressBar2 = true;

    // // We retrieve user's role
    // this.dataService.getRole().subscribe(res => {
    //   ;
    //   if ((res == 'superadmin') || (res == 'admin')) {
    //     this.displayedColumns = ['reference', 'value', 'status', 'creation_date', 'actions'];
    //   }
    // });

    // Retrieve all orders related to the user
    this.route.params.subscribe(params => {
      let data = {}
      data['user_id'] = params.id
      this.dataService.getOrders(data).subscribe(orders => {
        console.log(orders)
        this.orders = orders;
        this.dataSource.data = this.orders;
        this.showOrderFamilyProgressBar = false;

      });

      // If a reference parameter is present in URL, we show that order's information
      if (params.reference) {
        this.isList = false;
        if (params.reference != 'new') {
          this.isNew = false;
          this.ordersListSubs = this.dataService
            .getOrder(params) //cambiar por id en el html
            .subscribe(res => {

              this.orders = res;
              // this.orderForm.controls["id"].setValue(this.orders.id);
              // this.orderForm.controls["reference"].setValue(this.orders.reference);
              // this.orderForm.controls["value"].setValue(this.orders.value);

              this.creation_date = this.orders.creation_date;
              this.modification_date = this.orders.modification_date;
              this.url_invoice = this.orders.url_invoice;
              this.reference = this.orders.reference;
              this.value = this.orders.value;
              this.value_shipping = this.orders.value_shipping;
              this.total = this.orders.total;
              this.status = this.orders.status;
              this.product_photo = [{ "imageUrl": this.orders['product_photo'] }]

              this.dataService.getProductsOrder({ "reference": this.orders.reference }).subscribe(orders => {
                this.productsOrder = orders;
                this.dataSource2.data = this.productsOrder;
                this.showOrderFamilyProgressBar2 = false;
              });

            },
              console.error
            );
        }
        else {
          this.isNew = true;
        }


      }
      else {
        this.isList = true;
      }
    });
  }

  goTo(orderID: string) {
    this.router.navigateByUrl(`order/${orderID}`);
  }

  async downloadPhoto(urlPhoto: string, id_photo: string, product_name: string = '', disable_cancel: boolean = false) {

    // let popupResponse = await this._dialog.open(ConfirmPopupComponent,
    //   { autoFocus: false, data: { title: this.translate.instant('alerts.confirm_action'), message: this.translate.instant('alerts.are_you_sure') }, panelClass: "no-padding", disableClose: true, width: '400px' }).afterClosed().toPromise()

    // console.log(this.orders)
    return

    this.dataService.disableCancelOrder(this.orders.id).subscribe((r) => {
      if (r) {
        this.dataService.getFile(urlPhoto + '_original', "image/jpeg").subscribe(res => {
          let name = urlPhoto.split('/')

          console.log(name)

          var blob = new Blob([res], { type: 'image/jpg' });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.setAttribute("target", "_blank");
          if (product_name) {
            link.download = name[2] + '-' + product_name + '.jpeg';
          }
          else {
            link.download = name[2] + '.jpeg';
          }
          link.click();
          this.dataService.changeStatusTodownloaded(id_photo).subscribe(res => {
            let index = 0
            this.dataSource2.data.forEach(element => {
              if (element.id == id_photo) {
                this.dataSource2.data[index].downloaded = true
              }
              index += 1
            });
          })
        })
      }
      else {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: this.translate.instant(''), duration: 4000, panelClass: "error-snackbar" })
      }
    })
  }

  downloadZip(urlPhoto: string, id_photo: string) {
    this.showPrimarySpinner = true
    this.dataService.getFile(urlPhoto + '.zip', 'application/zip').subscribe(res => {
      this.showPrimarySpinner = false
      let name = urlPhoto.split('/')

      var blob = new Blob([res], { type: 'application/zip' });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute("target", "_blank");
      link.download = name[1] + '.zip';
      link.click();
    })
  }

  downloadInvoice(urlPhoto: string) {
    this.dataService.getFile(urlPhoto, 'application/pdf').subscribe(res => {
      let name = urlPhoto.split('/')

      var blob = new Blob([res], { type: 'application/pdf' });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute("target", "_blank");
      link.download = name[1] + '.pdf';
      link.click();
    })

  }

  applyFilter(text: any) {
    const filterValue = (text.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  newOrder() {
    this.router.navigateByUrl(`order/new`);
  }

  cancelOrder(order_id: string) {
    // alert(order_id)
    // return false
    let popup_content = {}

    this.translate.get('alerts.atention').subscribe(res => {
      popup_content['title'] = res;
    })

    this.translate.get('alerts.confirm_order_cancel').subscribe(res => {
      popup_content['message'] = res;
    })

    this.translate.get('buttons.ok').subscribe(res => {
      popup_content['ok_txt'] = res;
    })

    let dialogRef = this.dialog.open(ConfirmReservationDialogComponent,
      {
        data: {
          title: popup_content['title'],
          message: popup_content['message'],
          ok_txt: popup_content['ok_txt'],
          cancel: true
        }
      }).afterClosed().subscribe(res => {

        if (res) {
          this.showOrderFamilyProgressBar = true;

          this.dataService.cancelOrder(order_id).subscribe(res => {
            if (res.status == 'ok') {
              this.translate.get('alerts.order_canceled').subscribe((res: string) => {
                this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
              })
              this.route.params.subscribe(params => {
                let data = {}
                data['user_id'] = params.id
                this.dataService.getOrders(data).subscribe(orders => {
                  this.orders = orders;
                  this.dataSource.data = this.orders;
                  this.showOrderFamilyProgressBar = false;
                });
              })
            }
            else {
              this.translate.get('alerts.cancel_order_error').subscribe((res: string) => {
                this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
              })
            }
          });
        } else {
          console.log("Cancel ordered canceled.")
        }

      })



  }


  // saveOrder(){
  //   var params={};
  //   params['name'] = this.orderForm.controls["name"].value;
  //   params['id'] = this.orderForm.controls["id"].value;
  //   params['description'] = this.orderForm.controls["description"].value;



  //   if(params['name'] == ''){
  //     this.translate.get('alerts.name_required').subscribe((res: string) =>{
  //       alert(res);
  //     })
  //     return false;
  //   }


  //   this.dataService.saveOrder(params).subscribe( data => {
  //     if (data == ''){
  //       this.router.navigateByUrl(`orders`);
  //     }
  //     else{
  //       alert(data);
  //     }
  //   })
  // }

}